import { render } from "./BlogDetails.vue?vue&type=template&id=00d7a0bc&scoped=true"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"

import "./BlogDetails.vue?vue&type=style&index=0&id=00d7a0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d7a0bc"]])

export default __exports__